import React from 'react';
import { SvgIconProps } from '@mui/material';

export const withRightToLeftMirroring = (IconComponent: React.FC<SvgIconProps>) => {
    const IconComponentWithRightToLeftMirroring = (props: SvgIconProps) => (
        <IconComponent
            {...props}
            sx={{
                ...props.sx,
                '[dir="rtl"] &': {
                    transform: 'scale(-1, 1)',
                },
            }}
        />
    );

    IconComponentWithRightToLeftMirroring.muiName = IconComponent.name;

    return IconComponentWithRightToLeftMirroring;
};
